import React, { Component } from 'react';

import { StringUtils } from '../utils';
import { Routes as routes } from '../navigation';

class PracticeAdmins extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  renderPracticeAdmins = (staffMembers) => {
    if (!staffMembers || staffMembers.length === 0) {
      return null
    }

    const adminsArray = staffMembers.map((member) => {
      const userDetails =  member.user_details && member.user_details[0] ? member.user_details[0] : null;
      if (member.admin === true && userDetails) {
        return <span key={userDetails._id} style={{ fontSize: 15, color: 'grey' }}>{ StringUtils.displayName(userDetails) }</span>
      }
    }).filter((mem) => { return mem });

    return <div className="basic-container">
      <div className="flex-container flex-container-row" style={{ justifyContent: 'space-between' }}>
        <h4>Admins</h4>
        <span   className="button-clear-blue flex-container flex-container-row"
                style={{ color: '#1dc2ff', alignItems: 'center' }}
                onClick={ () => {
                  this.props.practiceActions.openEditAdmins();
                }}>
          EDIT
        </span>
      </div>

      <div className="flex-container flex-container-column">
        Current Admins
        { adminsArray }
      </div>
    </div>
  }

  render() {

    const staffMembers = this.props.staff || [];

    return this.renderPracticeAdmins(staffMembers);
  }

}


export default PracticeAdmins
